export const PromptTokenRatio = {
  ASK_GENE: 2,
  ASK_MY_DOCS: 1,
  TRANSLATIONS: 4
} as const;
